import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './ee5fee0674eb0c2fa6aad9e4d45615b5ada0824bbef9a406ca6638dc865ab8ba.cfe-internal.js';

var _excluded = ["children", "href", "target", "className"];
var Link = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '#' : _ref$href,
      _ref$target = _ref.target,
      target = _ref$target === void 0 ? '_self' : _ref$target,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var classes = classNames(className, styles.link);
  var rel = target !== '_self' ? 'noopener noreferrer' : undefined;
  return /*#__PURE__*/React__default.createElement("a", _extends({}, rest, {
    ref: ref,
    href: href,
    target: target,
    rel: rel,
    className: classes
  }), children);
});
var Link$1 = Link;

export { Link$1 as default };
